module.exports = __webpack_public_path__ + "static/BrandProtection-454567c89001a31d2607a5ed2e6426a3.jpg";